import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

const CommunityGallery = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [isExpanded, setIsExpanded] = useState(false); // Yeni state

    const allImages = Array.from({ length: 47 }, (_, i) => `/images/community/community (${i + 3}).jpg`);

    const openModal = (imageSrc) => {
        setSelectedImage(imageSrc);
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    const handleShowMore = () => {
        setIsExpanded(true); // Tıklanınca genişletme durumunu true yap
    };

    return (
        <>
            <section className="gallery-section py-5">
                <div className="container text-center">
                    <h2 className="cb-title mb-4">Our Community in Pictures</h2>
                    <p className="lead text-muted mb-5">A glimpse into the vibrant moments we've shared together.</p>

                    <div className={`gallery-grid ${isExpanded ? 'show-all' : ''}`}>
                        {allImages.map((src, index) => (
                            <div key={index} className="gallery-item" onClick={() => openModal(src)}>
                                <img src={src} alt={`Community Event ${index + 1}`} loading="lazy" />
                            </div>
                        ))}
                    </div>

                    {!isExpanded && ( // Genişletilmemişse butonu göster
                        <button
                            className="btn btn-primary mt-4"
                            onClick={handleShowMore}
                        >
                            More Photos
                        </button>
                    )}
                </div>
            </section>

            <Modal show={showModal} onHide={closeModal} size="xl" centered>
                <Modal.Body style={{ padding: 0 }}>
                    <img src={selectedImage} alt="Enlarged community view" style={{ width: '100%', height: 'auto' }} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CommunityGallery;